/**
 * Migração de preferências antigas para o novo formato unificado
 * 
 * Chave antiga → Chave nova:
 * - manager-expanded-sections → prefs-{userId}-manager-expandedSections
 * - sound-preferences → prefs-{userId}-global-sound
 * 
 * Esta função deve ser chamada UMA VEZ após login bem-sucedido
 */

const MIGRATION_FLAG_KEY = 'prefs-migration-v1-done';

export function migrateOldPreferences(userId: string): void {
  // Verificar se já migrou para este usuário
  const migrationKey = `${MIGRATION_FLAG_KEY}-${userId}`;
  if (localStorage.getItem(migrationKey)) {
    return; // Já migrou
  }
  
  console.log('[Migration] Iniciando migração de preferências para:', userId);
  let migratedCount = 0;
  
  try {
    // 1. Migrar manager-expanded-sections
    const oldManagerSections = localStorage.getItem('manager-expanded-sections');
    if (oldManagerSections) {
      const newKey = `prefs-${userId}-manager-expandedSections`;
      // Só migrar se a nova chave ainda não existir
      if (!localStorage.getItem(newKey)) {
        localStorage.setItem(newKey, oldManagerSections);
        migratedCount++;
        console.log('[Migration] Migrado: manager-expanded-sections');
      }
      // Remover chave antiga após migração
      localStorage.removeItem('manager-expanded-sections');
    }
    
    // 2. Migrar sound-preferences
    const oldSound = localStorage.getItem('sound-preferences');
    if (oldSound) {
      const newKey = `prefs-${userId}-global-sound`;
      // Só migrar se a nova chave ainda não existir
      if (!localStorage.getItem(newKey)) {
        localStorage.setItem(newKey, oldSound);
        migratedCount++;
        console.log('[Migration] Migrado: sound-preferences');
      }
      // Remover chave antiga após migração
      localStorage.removeItem('sound-preferences');
    }
    
    // Marcar migração como concluída
    localStorage.setItem(migrationKey, new Date().toISOString());
    
    if (migratedCount > 0) {
      console.log(`[Migration] Migração concluída: ${migratedCount} preferência(s) migrada(s)`);
    } else {
      console.log('[Migration] Nenhuma preferência antiga encontrada');
    }
    
  } catch (e) {
    console.error('[Migration] Erro durante migração:', e);
  }
}

